"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Intro.js options default proptypes.
 * @type {Object}
 */
var options = exports.options = {
  hidePrev: true,
  hideNext: true
};


//////////////////
// WEBPACK FOOTER
// ./~/intro.js-react/lib/helpers/defaultProps.js
// module id = 326
// module chunks = 0